/**
 * Blog Posts Index - MDX-only architecture
 *
 * All blog posts are stored as MDX files in src/data/blog-mdx/. The lightweight
 * metadata below is generated from those files; post bodies load per route.
 *
 * Posts are ordered newest first, with drafts gated by publish date.
 * Each post includes:
 * Add a post by creating its MDX file and running npm run generate:blog-index.
 */

import { blogPosts } from './blog-posts-lite.js';

/**
 * Blog posts array - MDX-only
 * All posts loaded from MDX files, sorted newest first
 */
export { blogPosts };

/**
 * Helper functions for blog management
 */

// Get published posts only
export const getPublishedPosts = () => {
  return blogPosts.filter(post => post.status === 'published');
};

// Get draft posts only
export const getDraftPosts = () => {
  return blogPosts.filter(post => post.status === 'draft');
};

// Get posts by pillar
export const getPostsByPillar = (pillar) => {
  return blogPosts.filter(post => post.pillar === pillar);
};

// Get posts by semantic cluster
export const getPostsByCluster = (cluster) => {
  return blogPosts.filter(post => post.semanticCluster === cluster);
};

// Get post by slug
export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

// Get post by ID
export const getPostById = (id) => {
  return blogPosts.find(post => post.id === id);
};

// Get related posts for a given post
export const getRelatedPosts = (postId) => {
  const post = getPostById(postId);
  if (!post || !post.relatedArticles) return [];

  return post.relatedArticles
    .map(id => getPostById(id))
    .filter(Boolean); // Remove any null/undefined
};

export default blogPosts;
